<template>
  <PageHeader title="Réclamations" />

  <Table :columns="columns" :data="getIndex" :is-accessible="true" @view="goToShowPage">
    <template #status="{ row }">
      <FieldSpan
        :value="row.status"
        :style-to-add="statusStyle(row.status)"
        translationPrefix="complaints.status"
      ></FieldSpan>
    </template>
  </Table>
  <Pagination
    :currentPage="currentPage"
    :totalPages="totalPages"
    :totalCount="totalCount"
    @changePage="handleChangePage"
  />
</template>

<script>
import { PageHeader, Table, FieldSpan, Pagination } from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "Complaints",
  components: {
    PageHeader,
    Table,
    FieldSpan,
    Pagination,
  },

  async mounted() {
    await this.fetchIndex({ page: this.currentPage });
  },

  computed: {
    ...mapGetters("complaints", ["getIndex", "statusStyle"]),
    ...mapState("complaints", {
      currentPage: (state) => state.currentPage,
      totalPages: (state) => state.totalPages,
      totalCount: (state) => state.totalCount,
    }),
    columns() {
      return [
        { label: "Identifiant", field: "friendlyId" },
        { label: "Contrat", field: "planSaleFriendlyId" },
        { label: "Statut", field: "status", slot: "status" },
        { label: "Date de réception", field: "receptionDate" },
      ];
    },
  },

  methods: {
    ...mapActions("complaints", ["fetchIndex"]),

    goToShowPage(row) {
      this.$router.push(`/complaints/${row.id}`);
    },

    handleChangePage(page) {
      this.fetchIndex({ page });
    },
  },
};
</script>
